import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import CheckIcon from '@material-ui/icons/Check';
import Grid from '@material-ui/core/Grid';
import ComponentLayout from './ComponentLayout';
import HeadingGroup from './HeadingGroup';
import CardComponent from './CardComponent';

const PricingCard = (props) => {
    const data = props.pricingCardData;
    const cardStyles = `pricing-card ${data.description && 'no-check-list'}`;
    return (
        <div className={cardStyles}>
            <div className="top-wrapper">
                <img className="main-image" src={data.image} alt={data.heading} />
                {data.heading &&(<h3 className="heading medium-font">{data.heading}</h3>)}
                {data.subHeading && (<h4 className="sub-heading medium-font">{data.subHeading}</h4>)}
                {(data.hrLine || !data.description) && <hr/>}
                {data.price &&(<h3 className="price large-font">{data.price}</h3>)}
                {data.description && (<h4 className="description medium-font">{data.description}</h4>)}
                {data.checkList && (<div className="check-list-wrapper">
                    {data.checkList.map((list) => {
                        const listStyles = `check-list-item small-font ${list.crossOut && 'cross-text'}`;
                        return (
                            <div className={listStyles}>
                                {/* <CheckIcon className="icon" /> */}
                                <p>{list.text}</p>
                            </div>
                        )
                    })}
                </div>)}
            </div>
                <div className="button-wrapper">
                <Link className="yellow-button" to="/contact-us">Contact Us</Link>
                </div>
                
        </div>
    );
};

PricingCard.propTypes = {
    pricingCardData: PropTypes.any,
}

export default PricingCard;